// extracted by mini-css-extract-plugin
export default {"category":"category_category__n9fOn","category_container":"category_category_container__U37Nr"};